module.exports = __webpack_public_path__ + "img/iceberg.6c45c2e3.png";